<template>
  <div>
    <h3>{{ user.first_name }} {{ user.last_name }}</h3>
    <hr>
    <h4>Phone Interview Notes</h4>
    <div class="editor">
      <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
      <editor-menu-bar :editor="descriptionEditor" v-slot="{ commands, isActive }" class="mb-1">
        <div class="menubar">
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
            <strong>B</strong>
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
            <i>Italics</i>
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
            <u>U</u>
          </button>
          <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
            Image
          </button> -->
          <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
            Image
          </button> -->
          <!-- https://github.com/scrumpy/tiptap/issues/89 -->
          <!-- https://codesandbox.io/s/j3p0z44155 -->
          <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
            Image
          </button> -->
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.paragraph() }" @click.prevent="commands.paragraph">
            p
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
            H1
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
            H2
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
            H3
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
            List
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
            1. 2. 3...
          </button>
          <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
            ""
          </button> -->
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
            ---
          </button>
          <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
            Undo
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
            Redo
          </button> -->
        </div>
      </editor-menu-bar>
      <editor-content class="editor__content" :editor="descriptionEditor" />
    </div>

    <h4 class="mt-4">Interview Notes</h4>
    <div class="editor">
      <!-- <Modal ref="ytmodal" @onConfirm="addCommand" /> -->
      <editor-menu-bar :editor="richEditor2" v-slot="{ commands, isActive }" class="mb-1">
        <div class="menubar">
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bold() }" @click.prevent="commands.bold">
            <strong>B</strong>
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.italic() }" @click.prevent="commands.italic">
            <i>Italics</i>
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.underline() }" @click.prevent="commands.underline">
            <u>U</u>
          </button>
          <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="showImagePrompt(commands.image)">
            Image
          </button> -->
          <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="uploadImage(commands.image)">
            Image
          </button> -->
          <!-- https://github.com/scrumpy/tiptap/issues/89 -->
          <!-- https://codesandbox.io/s/j3p0z44155 -->
          <!-- <button class="btn btn-grey btn-sm menubar__button" @click.prevent="openModal(commands.image);">
            Image
          </button> -->
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.paragraph() }" @click.prevent="commands.paragraph">
            p
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 3 }) }" @click.prevent="commands.heading({ level: 2 })">
            H1
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 4 }) }" @click.prevent="commands.heading({ level: 3 })">
            H2
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.heading({ level: 5 }) }" @click.prevent="commands.heading({ level: 4 })">
            H3
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.bullet_list() }" @click.prevent="commands.bullet_list">
            List
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.ordered_list() }" @click.prevent="commands.ordered_list">
            1. 2. 3...
          </button>
          <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.blockquote() }" @click.prevent="commands.blockquote">
            ""
          </button> -->
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.horizontal_rule() }" @click.prevent="commands.horizontal_rule">
            ---
          </button>
          <!-- <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.undo() }" @click.prevent="commands.undo">
            Undo
          </button>
          <button class="btn btn-grey btn-sm menubar__button" :class="{ 'is-active': isActive.redo() }" @click.prevent="commands.redo">
            Redo
          </button> -->
        </div>
      </editor-menu-bar>
      <editor-content class="editor__content" :editor="richEditor2" />
    </div>

    <!-- <div class="field-of-fields">
      <label>Score</label>
      <multiselect  class="" v-model="score" :options="scores" :multiple="false" :searchable="false" :close-on-select="true" :show-labels="false" placeholder=""></multiselect>
    </div> -->

    <button class="mylisting-button dark-button mt-3" @click="save()">Save</button>

    <!-- <p>{{ user.richtext1 }}</p> -->

    <modal name="notes-saved-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Notes saved!</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('notes-saved-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';

// https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Export/index.vue
// Import the editor
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
// import Icon from 'Components/Icon'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
  Image, // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
} from 'tiptap-extensions'

export default {
  // props: ['user'],
  props: ['userID'],
  components: {
    EditorContent,
    EditorMenuBar,
    // Datepicker, // https://www.npmjs.com/package/vuejs-datepicker
  },
  data() {
    return {
      description: '',
      descriptionEditor: null,

      richField2: '',
      richEditor2: null,

      user: {},

      score: null,
      scores: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60],
    }
  },
  mounted() {
    this.descriptionEditor = new Editor({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3, 4, 5] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: ({ getJSON, getHTML }) => {
        // this.json = getJSON()
        // this.html = getHTML()
        this.description = getHTML()
      },
    })

    this.richEditor2 = new Editor({
      // content: this.description,
      content: '',
      autoFocus: true,
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3, 4, 5] }),
        new HorizontalRule(),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new Image(), // https://github.com/scrumpy/tiptap/blob/master/examples/Components/Routes/Images/index.vue
      ],
      onUpdate: ({ getJSON, getHTML }) => {
        // this.json = getJSON()
        // this.html = getHTML()
        this.richField2 = getHTML()
      },
    })

    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h5>1. Family Name</h5><p></p><hr>\
    //     <h5>2. Family Address</h5><p></p><hr>\
    //     <h5>3. Mom’s full name / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>4. Dad’s full name  / occupation /cell # /work # / email</h5><p></p><hr>\
    //     <h5>5. Children’s Full Name & Birthday</h5><p></p><hr>\
    //     <h5>6. Allergies / Special Needs regarding the children</h5><p></p><hr>\
    //     <h5>7. Pets (kind – temperament – indoor/outdoor – care needed)</h5><p></p><hr>\
    //     <h5>8. Children’s interests/hobbies</h5><p></p><hr>\
    //     <h5>9. Behaviour modification strategies</h5><p></p><hr>\
    //     <h5>10. Emergency contact (name, relation & number)</h5><p></p><hr>\
    //     <h5>11. Days & Times required</h5><p></p><hr>\
    //     <h5>12. Start day/end day (contract duration)</h5><p></p><hr>\
    //     <h5>13. Driver’s license/vehicle required?</h5><p></p><hr>\
    //     <h5>14. Open to the Nanny taking the children to activities?</h5><p></p><hr>\
    //     <h5>15. Car Seats provided?</h5><p></p><hr>\
    //     <h5>16. Expectations for your Nanny</h5><p></p><hr>\
    //     <h5>17. Daily Routine for the Nanny</h5><p></p><hr>\
    //     <h5>Process going forward: </h5><p>Medical Release & Transportation Consent must be completed prior to the first shift</p><p>Client to email dates and times – 1-2 weeks in advance</p><p></p><hr>\
    //     <h5>TNC</h5><p>Communication Log to be completed & sent with first shift</p><p>Once the shift is filled send the NOC profile to client</p><p>Build the NOC Family spec sheet – send to Nanny </p><p></p><hr>\
    //     '
    //   )
    // }
    this.getUser()
  },
  beforeDestroy() {
    this.descriptionEditor.destroy()
    this.richEditor2.destroy()
  },
  created() {
    // if (this.user.richtext1) {
    //   this.descriptionEditor.setContent(this.user.richtext1)
    // }
    // else {
    //   this.descriptionEditor.setContent(
    //     '<h4>1. Family Name</h4><p></p><hr>\
    //     '
    //   )
    // }
  },
  methods: {
    getUser() {
      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        // container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
      },2000)

      axios.get(`/api/people/?id=${this.userID}`)
        .then(res => {
          this.user = res.data[0]

          if (this.user.richtext1) {
            this.descriptionEditor.setContent(this.user.richtext1)
            this.description = this.user.richtext1
          }
          else {
            // this.descriptionEditor.setContent(
            //   '<h5>Why do you want to be a nanny?</h5><p></p><hr>\
            //   <h5>How would your best friend describe your personality?</h5><p></p><hr>\
            //   '
            // )

            axios.get(`/api/richtemplates/?agency=${this.$store.getters.agencyID}&selector2=Candidate Interview 1`)
              .then(res => {
                console.log(res)
                if (res.data.length) {
                  this.descriptionEditor.setContent(res.data[0].body)
                }
                else {
                  this.descriptionEditor.setContent('')
                }
              })
          }

          if (this.user.richtext2) {
            this.richEditor2.setContent(this.user.richtext2)
            this.richField2 = this.user.richtext2
          }
          else {
            axios.get(`/api/richtemplates/?agency=${this.$store.getters.agencyID}&selector2=Candidate Interview 2`)
              .then(res => {
                console.log(res)
                if (res.data.length) {
                  this.richEditor2.setContent(res.data[0].body)
                }
                else {
                  this.richEditor2.setContent('')
                }
              })
          }

          this.score = this.user.integer1
        })
        .catch(error => console.log(error))
    },
    save() {
      axios.patch(`/api/people/${this.user.id}/`, {
        richtext1: this.description,
        richtext2: this.richField2,
        integer1: this.score,
      })
        .then(res => {
            console.log(res)
            this.getUser()
            this.$modal.show('notes-saved-modal')
          })
          .catch(error => console.log(error))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/CandidateInterview.vue